export interface IUserData {
    created_at?: string;
    email?: string;
    first_name?: string;
    id: string;
    approval_status?: 'pending' | 'approved' | 'rejected' | 'invited';
    last_name?: string;
    phone?: string;
    role?: "travel_designer" | "traveler" | "admin";
    specialization?: string;
    updated_at?: string;
    years_experience?: string;
    avatar_url?: string;
}

export class UserData implements IUserData {
    created_at: string;
    email: string;
    first_name: string;
    id: string;
    approval_status: 'pending' | 'approved' | 'rejected' | 'invited';
    last_name: string;
    phone: string;
    role: "travel_designer" | "traveler" | "admin";
    specialization: string;

    updated_at: string;
    years_experience: string;
    avatar_url: string;

    constructor(data: IUserData) {
        this.created_at = data?.created_at;
        this.email = data?.email;
        this.first_name = data?.first_name;
        this.id = data?.id;
        this.approval_status = data?.approval_status;
        this.last_name = data?.last_name;
        this.phone = data?.phone;
        this.role = data?.role;
        this.specialization = data?.specialization;
        this.updated_at = data?.updated_at;
        this.years_experience = data?.years_experience;
        this.avatar_url = data?.avatar_url;
    }
}